import React from 'react';
import { IconButton } from '@mui/material';
import { Edit as EditIcon, Storage as StorageIcon } from '@mui/icons-material';
import SidebarPanelHeader from '../SidebarPanelHeader';

interface CRMMappingHeaderProps {
  onEdit: () => void;
  showEditButton: boolean;
  actionButtons: React.ReactNode[];
}

const CRMMappingHeader: React.FC<CRMMappingHeaderProps> = ({
  onEdit,
  showEditButton,
  actionButtons
}) => {
  const editButton = showEditButton
    ? [
        <IconButton
          key="edit"
          size="small"
          onClick={onEdit}
          sx={{ color: 'text.secondary' }}
          title="Edit Mapping"
        >
          <EditIcon fontSize="small" />
        </IconButton>
      ]
    : undefined;

  return (
    <SidebarPanelHeader
      icon={<StorageIcon />}
      title="CRM Sync"
      infoTooltip="Map your table columns to Salesforce CRM fields. Configure which fields should be overwritten during sync operations. This allows you to sync data from your campaign table to Salesforce."
      actionButtons={
        [
          ...(editButton ?? []),
          ...(actionButtons ?? [])
        ] as React.ReactElement[]
      }
    />
  );
};

export default CRMMappingHeader;
